import { BillStatementStatusV2 } from 'apollo/queries/autogenerate/schemas';

export function shouldHidePaymentMethod(
  unpaidAmount: number,
  billStatus: BillStatementStatusV2
) {
  return unpaidAmount === 0 || billStatus === BillStatementStatusV2.PAID;
}
